import React from "react";

const OfficeLocations = () => {
  const officeLocations = [
    {
      city: "Christchuch, New Zealand",
      address: ["Christchurch 8023", "New Zealand"],
    },
    {
      city: "Wellington, New Zealand",
      address: ["Wellington 6011", "New Zealand"],
    },
    {
      city: "Auckland, New Zealand",
      address: ["Auckland Central", "Auckland 1010"],
    },
    {
      city: "Sydney, Australia",
      address: ["Sydney 2000", "Australia"],
    },
    {
      city: "Melbourne, Australia",
      address: ["Melbourne 3001", "Australia"],
    },
  ];

  return (
    <section className="bg-black px-4 py-20">
      <div
        className="max-w-5xl mx-auto flex flex-col lg:flex-row gap-10 items-start"
        data-aos="fade-up"
      >
        {/* Left: Office Info */}
        <div className="flex-1">
          <h2 className="text-4xl font-serif text-text mb-8">Our offices</h2>

          <div className="space-y-6 text-text text-sm leading-relaxed">
            {officeLocations.map((office, index) => (
              <div key={index}>
                <p className="font-semibold text-text">{office.city}</p>
                {office.address.map((line, i) => (
                  <p key={i} className="text-textGray text-sm">
                    {line}
                  </p>
                ))}
              </div>
            ))}
          </div>
        </div>

        {/* Right: Image */}

        <div className="block lg:hidden w-full aspect-square bg-transparent border border-border p-3">
          <img
            src="/images/img_02.jpg"
            alt="Our Team"
            className="w-full aspect-square object-cover rounded-xl shadow-sm"
          />
        </div>

        {/* Desktop view */}
        <div className="hidden lg:block ">
          <img
            src="/images/img_02.jpg"
            alt="Our Team"
            className="rounded-2xl max-w-lg object-cover shadow-md"
          />
        </div>
      </div>
    </section>
  );
};

export default OfficeLocations;
